import { render, staticRenderFns } from "./manual-ekyc.vue?vue&type=template&id=7573b992&"
import script from "./manual-ekyc.vue?vue&type=script&lang=js&"
export * from "./manual-ekyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports